import { MerryButton } from "@/shared/ui/MerryButton";
import { MerrySearchField } from "@/shared/ui/MerrySearchField";
import "./merry-popup-search-toolbar.css";

interface MerryPopupSearchToolbarProps {
  value: string;
  onSearchChange: (value: string) => void;
  placeholder: string;
  "aria-label"?: string;
  actionIcon: string;
  actionLabel: string;
  onAction: () => void;
  isActionDisabled?: boolean;
}

export function MerryPopupSearchToolbar({ value, onSearchChange, placeholder, "aria-label": ariaLabel, actionIcon, actionLabel, onAction, isActionDisabled }: MerryPopupSearchToolbarProps) {
  return <div className="merry-popup-search-toolbar">
    <MerrySearchField aria-label={ariaLabel ?? placeholder} className="merry-popup-search-toolbar__search" value={value} onChange={onSearchChange} placeholder={placeholder} size={34} />
    <MerryButton hierarchy="level1" size={34} isDisabled={isActionDisabled} onPress={onAction} icon={<img alt="" aria-hidden="true" src={actionIcon} />}>{actionLabel}</MerryButton>
  </div>;
}
